import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LazyImage from './atoms/LazyImage';
import { LanguageSwitcher } from './atoms';

const IroriTourismSiteWithImages = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    service: ''
  });

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert(t('contact.thankYou'));
    setIsModalOpen(false);
  };

  // サービスデータ - 翻訳キーを使用
  const services = [
    {
      id: 'vip-car',
      title: t('services.vipCar.title'),
      subtitle: t('services.vipCar.subtitle'),
      description: t('services.vipCar.description'),
      features: t('services.vipCar.features', { returnObjects: true }) || [],
      color: 'bg-orange-500',
      imageUrl: '',
      fallbackUrl: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"%3E%3Crect width="400" height="300" fill="%23f97316"%3E%3C/rect%3E%3Ctext x="200" y="150" text-anchor="middle" dy=".3em" font-family="Arial, sans-serif" font-size="16" fill="white"%3EVIPカー%3C/text%3E%3C/svg%3E'
    },
    {
      id: 'chiba-gourmet',
      title: t('services.chibaGourmet.title'),
      subtitle: t('services.chibaGourmet.subtitle'),
      description: t('services.chibaGourmet.description'),
      features: t('services.chibaGourmet.features', { returnObjects: true }) || [],
      color: 'bg-amber-500',
      imageUrl: '',
      fallbackUrl: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"%3E%3Crect width="400" height="300" fill="%23f59e0b"%3E%3C/rect%3E%3Ctext x="200" y="150" text-anchor="middle" dy=".3em" font-family="Arial, sans-serif" font-size="16" fill="white"%3E千葉グルメ%3C/text%3E%3C/svg%3E'
    },
    {
      id: 'nationwide',
      title: t('services.nationwide.title'),
      subtitle: t('services.nationwide.subtitle'),
      description: t('services.nationwide.description'),
      features: t('services.nationwide.features', { returnObjects: true }) || [],
      color: 'bg-blue-500',
      imageUrl: '',
      fallbackUrl: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"%3E%3Crect width="400" height="300" fill="%233b82f6"%3E%3C/rect%3E%3Ctext x="200" y="150" text-anchor="middle" dy=".3em" font-family="Arial, sans-serif" font-size="16" fill="white"%3E全国手配%3C/text%3E%3C/svg%3E'
    }
  ];

  const specialTours = [
    {
      title: t('specialTours.gameCompany.title'),
      description: t('specialTours.gameCompany.description'),
      imageUrl: '',
      fallbackUrl: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="200" viewBox="0 0 400 200"%3E%3Crect width="400" height="200" fill="%23374151"%3E%3C/rect%3E%3Ctext x="200" y="100" text-anchor="middle" dy=".3em" font-family="Arial, sans-serif" font-size="14" fill="white"%3Eゲーム制作現場%3C/text%3E%3C/svg%3E'
    },
    {
      title: t('specialTours.technicalVisit.title'),
      description: t('specialTours.technicalVisit.description'),
      imageUrl: '',
      fallbackUrl: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="200" viewBox="0 0 400 200"%3E%3Crect width="400" height="200" fill="%23059669"%3E%3C/rect%3E%3Ctext x="200" y="100" text-anchor="middle" dy=".3em" font-family="Arial, sans-serif" font-size="14" fill="white"%3E企業視察%3C/text%3E%3C/svg%3E'
    },
    {
      title: t('specialTours.deepCulture.title'),
      description: t('specialTours.deepCulture.description'),
      imageUrl: '',
      fallbackUrl: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="200" viewBox="0 0 400 200"%3E%3Crect width="400" height="200" fill="%23dc2626"%3E%3C/rect%3E%3Ctext x="200" y="100" text-anchor="middle" dy=".3em" font-family="Arial, sans-serif" font-size="14" fill="white"%3Eカルチャー体験%3C/text%3E%3C/svg%3E'
    },
  ];

  // SVG Icons
  const MenuIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  );

  const CloseIcon = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );

  const CarIcon = () => (
    <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
      <rect x="2" y="14" width="20" height="3" rx="0.5" />
      <path d="M4 14l1.5-5h13l1.5 5H4z" />
      <circle cx="6" cy="16.5" r="1.8" />
      <circle cx="18" cy="16.5" r="1.8" />
    </svg>
  );

  const UtensilsIcon = () => (
    <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
      <ellipse cx="12" cy="10" rx="6" ry="3.5" fill="currentColor" />
      <path d="M6 10 L2 7 L3 10 L2 13 Z" fill="currentColor" />
      <circle cx="15" cy="9" r="1" fill="white" />
    </svg>
  );

  const RouteIcon = () => (
    <svg className="w-8 h-8" fill="currentColor" viewBox="1 2 20 20">
      <rect x="3" y="8" width="16" height="8" rx="1" fill="currentColor" />
      <circle cx="6" cy="17" r="1.5" fill="currentColor" />
      <circle cx="16" cy="17" r="1.5" fill="currentColor" />
    </svg>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      {/* Header - 多言語対応版 */}
      <header className="bg-white shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">Icon</span>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-orange-700">IRORI</h1>
                <p className="text-sm text-gray-600">TOURISM</p>
              </div>
            </div>

            {/* Navigation - 多言語対応 */}
            <nav className="hidden md:flex items-center space-x-8">
              <a
                href="#services"
                className="text-sm font-medium hover:text-orange-500 transition-colors cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById('services');
                  if (element) {
                    const headerHeight = 80;
                    const elementPosition = element.offsetTop - headerHeight;
                    window.scrollTo({
                      top: elementPosition,
                      behavior: 'smooth'
                    });
                  }
                }}
              >
                {t('navigation.services')}
              </a>
              <a
                href="https://irori-japan.studio.site/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium hover:text-orange-500 transition-colors"
              >
                {t('navigation.about')}
              </a>

              {/* 言語切り替えコンポーネント */}
              <LanguageSwitcher />

              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200 text-sm font-medium"
              >
                {t('navigation.contact')}
              </button>
            </nav>

            <button
              className="md:hidden text-gray-700 hover:text-orange-500 transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>

          {/* Mobile Navigation - 多言語対応 */}
          {isMobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-4 pt-4">
                <a
                  href="#services"
                  className="text-sm font-medium hover:text-orange-500 transition-colors cursor-pointer py-2"
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('services');
                    if (element) {
                      const headerHeight = 270;
                      const elementPosition = element.offsetTop - headerHeight;
                      window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth'
                      });
                    }
                    setIsMobileMenuOpen(false);
                  }}
                >
                  {t('navigation.services')}
                </a>
                <a
                  href="https://irori-japan.studio.site/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-medium hover:text-orange-500 transition-colors py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {t('navigation.about')}
                </a>

                {/* モバイル用言語切り替え */}
                <div className="py-2">
                  <LanguageSwitcher variant="buttons" />
                </div>

                <button
                  onClick={() => {
                    setIsModalOpen(true);
                    setIsMobileMenuOpen(false);
                  }}
                  className="bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-all duration-200 text-sm font-medium text-left"
                >
                  {t('navigation.contact')}
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section - 多言語対応 */}
      <section
        className="relative min-h-screen flex items-center"
        style={{
          backgroundImage: 'url(/proxy/images/photos/1108701/pexels-photo-1108701.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-orange-900/30 to-transparent"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4">
          <div className="max-w-4xl">
            <div className="inline-block bg-orange-500/90 text-white px-4 md:px-6 py-2 rounded-full text-xs md:text-sm font-medium mb-6 md:mb-8 backdrop-blur-sm">
              {t('hero.badge')}
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6 drop-shadow-2xl">
              {t('hero.title').replace('{highlight}', '')}
              <br />
              <span className="text-orange-300">{t('hero.titleHighlight')}</span>
            </h1>
            <p className="text-lg md:text-xl lg:text-2xl text-gray-200 mb-8 md:mb-12 max-w-3xl drop-shadow-lg">
              {t('hero.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-orange-500 text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-medium hover:bg-orange-600 hover:-translate-y-1 hover:shadow-xl transition-all duration-200 backdrop-blur-sm"
              >
                {t('hero.ctaPrimary')}
              </button>
              <button
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-medium hover:bg-white hover:text-gray-900 hover:-translate-y-1 transition-all duration-200 backdrop-blur-sm"
              >
                {t('hero.ctaSecondary')}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section - 多言語対応 */}
      <section
        id="about"
        className="py-12 md:py-20 relative bg-gradient-to-br from-pink-50 to-orange-50"
      >
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-block bg-orange-100 text-orange-700 px-4 md:px-6 py-2 rounded-full text-xs md:text-sm font-medium mb-10">
              {t('features.badge')}
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              {t('features.title')}
            </h2>
            <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
              {t('features.subtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Services Section - 多言語対応 */}
      <section id="services" className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-block bg-amber-100 text-amber-700 px-4 md:px-6 py-2 rounded-full text-xs md:text-sm font-medium mb-10">
              {t('services.badge')}
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              {t('services.title')}
            </h2>
          </div>

          <div className="space-y-8 md:space-y-12">
            {services.map((service, index) => (
              <div key={service.id} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* 画像セクション */}
                  <div className="relative h-64 lg:h-full overflow-hidden">
                    <LazyImage
                      src={service.imageUrl}
                      alt={service.title}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                      fallbackSrc={service.fallbackUrl}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                    <div className="absolute bottom-4 left-4">
                      <div className={`${service.color} p-3 rounded-lg`}>
                        {index === 0 && <CarIcon className="text-white" />}
                        {index === 1 && <UtensilsIcon className="text-white" />}
                        {index === 2 && <RouteIcon className="text-white" />}
                      </div>
                    </div>
                  </div>
                  {/* コンテンツセクション */}
                  <div className="p-6 md:p-8 flex flex-col justify-center">
                    <span className="text-xs md:text-sm text-orange-600 font-medium mb-2">
                      {service.subtitle}
                    </span>
                    <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-4">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-base md:text-lg mb-6 leading-relaxed">
                      {service.description}
                    </p>

                    {/* 特徴リスト */}
                    <div className="mb-6">
                      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center text-sm text-gray-600">
                            <div className="w-2 h-2 bg-orange-500 rounded-full mr-3 flex-shrink-0"></div>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3">
                      <button
                        onClick={() => {
                          setSelectedService(service.title);
                          setIsModalOpen(true);
                        }}
                        className="bg-orange-500 text-white px-6 md:px-8 py-3 rounded-lg font-medium hover:bg-orange-600 transition-all duration-200 text-sm md:text-base"
                      >
                        {t('common.inquiry')}
                      </button>
                      <Link
                        to={
                          index === 0 ? '/vip-car' :
                            index === 1 ? '/chiba-gourmet' :
                              index === 2 ? '/nationwide-transport' : '#'
                        }
                        className="border-2 border-orange-500 text-orange-500 px-6 md:px-8 py-3 rounded-lg font-medium hover:bg-orange-500 hover:text-white transition-all duration-200 text-sm md:text-base inline-block text-center"
                      >
                        {t('common.readMore')}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Special Tours Section - 多言語対応 */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-block bg-blue-100 text-blue-700 px-4 md:px-6 py-2 rounded-full text-xs md:text-sm font-medium mb-10">
              {t('specialTours.badge')}
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              {t('specialTours.title')}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {specialTours.map((tour, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="relative h-48 overflow-hidden">
                  <LazyImage
                    src={tour.imageUrl}
                    alt={tour.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    fallbackSrc={tour.fallbackUrl}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3 className="text-white font-bold text-lg mb-2 drop-shadow-lg">
                      {tour.title}
                    </h3>
                    <p className="text-gray-200 text-sm drop-shadow">
                      {tour.description}
                    </p>
                  </div>
                </div>
                <div className="p-4">
                  <button
                    onClick={() => {
                      setSelectedService(tour.title);
                      setIsModalOpen(true);
                    }}
                    className="w-full bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors text-sm font-medium"
                  >
                    {t('common.inquiry')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Modal - 多言語対応 */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-4 md:p-6 border-b">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-xl md:text-2xl font-bold">{t('contact.title')}</h3>
                  {selectedService && (
                    <span className="inline-block bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-xs md:text-sm mt-2">
                      {selectedService}
                    </span>
                  )}
                </div>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700 text-xl md:text-2xl"
                >
                  ×
                </button>
              </div>
            </div>
            <div className="p-4 md:p-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t('contact.form.name')} *
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm md:text-base"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder={t('contact.form.name')}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t('contact.form.email')} *
                  </label>
                  <input
                    type="email"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm md:text-base"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    placeholder={t('contact.form.email')}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t('contact.form.phone')}
                  </label>
                  <input
                    type="tel"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm md:text-base"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    placeholder={t('contact.form.phone')}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t('contact.form.message')} *
                  </label>
                  <textarea
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm md:text-base"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    placeholder={t('contact.form.message')}
                  />
                </div>
              </div>
            </div>
            <div className="p-4 md:p-6 border-t flex justify-end space-x-4">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 md:px-6 py-2 text-gray-600 hover:text-gray-800 transition-colors text-sm md:text-base"
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={handleFormSubmit}
                className="bg-orange-500 text-white px-4 md:px-6 py-2 rounded-lg hover:bg-orange-600 transition-colors text-sm md:text-base"
              >
                {t('common.submit')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IroriTourismSiteWithImages;
